import type { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import type { ControllerDetails } from '#services/cve/ControllerDetails';

export const escalationErrorMock: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/EconomicSanctions$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'EconomicSanctions',
        statusCode: ControllerStatus.ESCALATION_ERROR,
        check: {
          requestorId: 'CVE',
          requestDateTime: '2024-05-21T13:29:56.409Z',
          responseDateTime: '2024-05-21T13:29:56.409Z',
          expirationDateTime: '2999-05-21T13:29:56.409Z',
          controlData: {
            sanctions: [
              {
                companyId: '113',
                sanctionId: '115250479-20230317135606274587',
                sanctionSource: {
                  originCode: 'Manual creation',
                  updateOriginCode: 'Manual creation',
                },
                sanctionTypeCode: 'SP',
                sanctionUpdateDateTime: '2023-03-17',
                sanctionCreationDate: '2023-03-17',
                isContinuatedSanction: true,
                sanctionEffectiveEndDate: '2025-03-17',
                isActive: true,
              },
            ],
            consecutiveSanctionsEndDate: '2025-03-17',
            rejectCode: 'ONGOING_SANCTION',
            escalationContact: 'test@allianz-trade.com',
          },
        },
        escalation: {
          requestorId: 'CVE',
          requestDateTime: '2024-05-21T13:29:56.409Z',
          responseDateTime: '2024-05-21T13:29:56.409Z',
          controlData: {
            errorDetails: 'Error: Failed to create ticket for companyId 113: 400 - Bad Request',
          },
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/PoliticalExposedPerson$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'PoliticalExposedPerson',
        statusCode: ControllerStatus.ESCALATION_ERROR,
        check: {
          requestDateTime: '2024-05-18T13:29:56.409Z',
          responseDateTime: '2024-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          expirationDateTime: '2025-05-21T13:29:56.409Z',
          controlData: {},
        },
        escalation: {
          requestorId: 'CVE',
          requestDateTime: '2024-05-21T13:29:56.409Z',
          responseDateTime: '2024-05-21T13:29:56.409Z',
          controlData: {
            errorDetails: 'Error: Failed to create ticket for companyId 113: 400 - Bad Request',
          },
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/EnergyPolicy$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'EnergyPolicy',
        statusCode: ControllerStatus.ESCALATION_ERROR,
        check: {
          requestDateTime: '2024-05-18T13:29:56.409Z',
          responseDateTime: '2024-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          expirationDateTime: '2025-05-21T13:29:56.409Z',
          controlData: {
            tradeSectors: [
              { code: '4265', isMain: false },
              { code: '1234', isMain: true },
              { code: '9856', isMain: false, isRestricted: true },
            ],
            escalationContact: 'test@allianz-trade.com',
            esgQuiz: {
              questions: {
                COMPANY_TYPE: 'SERVICE',
                SERVICE_NEW_COAL: false,
                SINGLE_MULTI_SITE: 'MULTI_SITE',
                SHORT_TERM_ALIGNMENT: false,
                DIVERSIFIED_CONGLOMERATE: false,
                SERVICE_RELATIVE_COAL_SHARE: true,
                CLIMATE_PLAN_THIRD_PARTY_APPROVAL: true,
              },
              mainQuestion: 'THERMAL_COAL',
            },
          },
        },
        escalation: {
          requestorId: 'CVE',
          requestDateTime: '2024-05-21T13:29:56.409Z',
          responseDateTime: '2024-05-21T13:29:56.409Z',
          controlData: {
            errorDetails: 'Error: Failed to create ticket for companyId 113: 400 - Bad Request',
          },
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/SensitiveCountry$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'SensitiveCountry',
        statusCode: ControllerStatus.ESCALATION_ERROR,
        check: {
          requestDateTime: '2024-05-18T13:29:56.409Z',
          responseDateTime: '2024-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          expirationDateTime: '2025-05-21T13:29:56.409Z',
          controlData: {
            countryCode: 'RU',
            escalationContact: 'test@allianz-trade.com',
          },
        },
        escalation: {
          requestorId: 'CVE',
          requestDateTime: '2024-05-21T13:29:56.409Z',
          responseDateTime: '2024-05-21T13:29:56.409Z',
          controlData: {
            errorDetails: 'Error: Failed to create ticket for companyId 113: 400 - Bad Request',
          },
        },
      } satisfies ControllerDetails,
    },
  },
];
